var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_486_1245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.28263 15.0949C8.28263 16.2577 7.4062 17.2736 6.26624 17.3049C5.0987 17.3361 4.13954 16.3796 4.13954 15.1949V2.12247C4.13954 0.950268 3.20795 0 2.0588 0H-0.000488281V15.8545C-0.000488281 19.3586 2.78506 22.2 6.22027 22.2H6.55123C9.79338 22.2 12.4227 19.518 12.4227 16.2108V12.9568C12.4227 12.9505 12.4196 12.9474 12.4135 12.9474H8.29182C8.28569 12.9474 8.28263 12.9505 8.28263 12.9568V15.0949Z",
    fill: "#2C4F8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4223 5.52637C12.4161 5.52637 12.41 5.52637 12.4039 5.52637H8.28223V9.78694H12.4039C12.41 9.78694 12.4161 9.78694 12.4223 9.78694C13.5683 9.77756 14.4938 8.8273 14.4938 7.65822C14.4938 6.48601 13.5683 5.53574 12.4223 5.52637Z",
    fill: "#2C4F8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_1245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 22.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpLogo);
export default __webpack_public_path__ + "static/media/upLogo.37f1d0f980d5a00446d0008347ebf003.svg";
export { ForwardRef as ReactComponent };